import React from "react";
import Item from "./Item";
import { connect } from "react-redux";
import { getLabelRoute } from "../../utils/GetRoute";

function List(props) {
  const {
    defaultReducer: { ecosystem_titles, texts },
    initiatives,
  } = props;
  let buttonName = ecosystem_titles.find(
    (item) => item.label === "ecosistema_detalle_boton"
  );
  buttonName = buttonName ? buttonName.value : "Ver detalle";
  const menu4 = getLabelRoute(texts, "menu_4");

  return (
    <div className="row">
      {initiatives.map((initiative) => (
        <Item
          key={initiative.id}
          initiative={initiative}
          buttonName={buttonName}
          baseUrl={menu4.slug}
        />
      ))}
    </div>
  );
}

const mapStateToProps = ({ defaultReducer }) => {
  return {
    defaultReducer,
  };
};

export default connect(mapStateToProps, null)(List);
